import { render, staticRenderFns } from "./MultipleUploadButtons.vue?vue&type=template&id=4b689f2c"
import script from "./MultipleUploadButtons.vue?vue&type=script&lang=js"
export * from "./MultipleUploadButtons.vue?vue&type=script&lang=js"
import style0 from "./MultipleUploadButtons.vue?vue&type=style&index=0&id=4b689f2c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports